import React from "react";
import Navbar2 from "../Components/Navbar2";
import CampCard from "../Components/CampCard";
import Footer from "../Components/Footer";

function BasketballCamps() {
  return (
    <>
    <Navbar2 />
      <div className="container-fluid px-0 pb-4 pt-5">
        <div className='h1 text-center'>
          BASKETBALL CAMPS
        </div>
          <div className="h4 pb-3 ms-5 me-5 fw-light">
            ADS Basketball Camps offer high-energy, skill-focused training 
            for players of all levels. With expert coaches, hands-on instruction,
            and a fun, team-first environment, athletes sharpen fundamentals,
            boost confidence, and grow their game. Whether you're new to basketball
            or leveling up, our camps are built to inspire and challenge. 
            Come train, compete, and have a blast with ADS!
          </div>
        <div className="container-fluid pt-3">
          <div className="row">
            <div className="col pt-3 pb-0 text-center">
              <div className="h1">
                Train Like a Pro!
              </div>
            </div>
            <div className="row row-cols-1 row-cols-md-3 rows-col-lg-3 g-3 pb-5">           
                <div className='col-12 col-md-6'>
                  <CampCard 
                    backgroundImage="./s3/feature_basketball_hoopers.jpg"
                    title={<>ADS Lil Hoopers Skills Lab<br/> (5-7 yr olds)</>}
                    buttonText="REGISTER NOW"
                    linkUrl="http://adssportscomplex.leagueapps.com/leagues/basketball/4853349-lil-hoopers--skills-lab--jan.-2026-650pm---750pm"
                    date_time={<>Jan 7th, 14th, 21st<br/>(3 Week Program)<br/>
                                6:50PM - 7:50PM</>}
                    earlyBirdPrice={<></>}
                    regularPrice={<>$30 per day<br/>$80 for all 3 weeks</>}
                    description={<>Basic Basketball skills: Intro to basketball, Footwork foundation,
                    Dribbling, skill development fun games, and techniques</>}
                    location={<>Randolph Air Force Base High School Gym</>}
                  />
                </div>
                <div className='col-12 col-md-6'>
                  <CampCard 
                    backgroundImage="./s3/feature_basketball_hoopers.jpg"
                    title={<>ADS Elementary Skills Lab<br/>(8-11 yr olds)</>}
                    buttonText="REGISTER NOW"
                    linkUrl="http://adssportscomplex.leagueapps.com/leagues/basketball/4853350-elementary-skills-lab---jan.-2026-750pm---850pm"
                    date_time={<>Jan 7th, 14th, 21st<br/>(3 Week Program)<br/>
                                7:50PM - 8:50PM</>}
                    earlyBirdPrice={<></>}
                    regularPrice={<>$30 per day<br/>$80 for all 3 weeks</>}
                    description={<>Basic Basketball skills: Intro to basketball, Footwork foundation,
                    Dribbling, skill development fun games, and techniques</>}
                    location={<>Randolph Air Force Base High School Gym</>}
                  />
                </div>
                {/* <div className='col-12 col-md-6'>
                  <CampCard 
                    backgroundImage="./s3/foundation_howscholarship.jpg"
                    title={<>ADS Middle/High School Skills Lab<br/>(12-18 yr olds)</>}
                    buttonText="REGISTER NOW"
                    linkUrl="https://adssportscomplex.leagueapps.com/leagues/basketball/4820877-middlehigh-school-skills-lab---dec.-2025-7pm---815pm?fbclid=IwY2xjawOaluxleHRuA2FlbQIxMABicmlkETF3UkV4cWk2dEFBU1FjSk8zc3J0YwZhcHBfaWQQMjIyMDM5MTc4ODIwMDg5MgABHm8petyomQ8sWFk59qXjiCrFirycU2WQCZnYOYL3n9KJycjhOhH845dmg79D_aem_SkJkQyCpGWI0ZZGVtyLtIw"
                    date_time={<>Dec 3rd, 10th, 17th<br/>(3 Week Program)<br/>7PM - 8:15PM</>}
                    earlyBirdPrice={<></>}
                    regularPrice={<>$30 per day<br/>$80 for all 3 weeks</>}
                    description={<>Basic Basketball skills: Boys & Girls, advancing scoring
                    techniques, in-game situational concepts, contact drills , Ball handling, 
                    shooting, passing, spacing, defense, and more.</>}
                    location={<>Randolph Air Force Base High School Gym</>}
                  />
                </div> */}
            </div> 
          </div>
          <div className="row text-center">
          <div className="col-sm-12 col-md-6 pt-3 d-flex align-items-center justify-content-center">
            <div className="h1">ADS &amp; John Hollmon Collaboration</div>
          </div>
          <div className="col-sm-12 col-md-6">
            <div className="ratio ratio-16x9">
              <video controls>
                <source src="./s3/ads_john_interview.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
        <div className="row pt-3">
          <div className="col">
            <div className="lead">
              Unlock your full potential by training under the elite guidance of
              John Hollmon, a master basketball trainer personally developed by global
              skills icon DJ Sackmann. John has trained NBA, WNBA, and top-tier
              professional athletes, bringing the same high-level standards to
              every session. What sets this program apart is the integration of
              advanced game film analysis—similar to the Synergy system used by
              pro teams—allowing players to break down their game, understand
              tendencies, and make real-time adjustments. This is not just training;
              it’s a pro-level experience designed to elevate your game to the next tier.
            </div>
          </div>
        </div>
        </div>
        
      </div>
      <div className="container-fluid pt-3">
        <div className="row">
          <div className="col p-3 text-center">
            <div className="h1">
              ADS TRAINERS
            </div>
          </div>
        </div>
      </div>
    <div className="container-fluid pt-3 pb-4">
      <div className="row row-cols-1 row-cols-md-3 row-col-lg-4 g-4">
        <div className="col-6 col-sm-12">
          <div className="card h-100">
            <img src="./s3/bhall.jpg" className="card-img-top" alt=""
             />
            <div className="card-body">
              <div className="card-title h3">Brian Hall</div>
              <div className="card-text h5">
                With 10+ years in player development and 5+ years of 
                coaching experience, Brian has worked with athletes from 
                youth levels to the NBA and WNBA. He&apos;s worked elite camps, 
                built high-level training systems, and has had 10+ players go 
                on to play professionally overseas.
              </div>
            </div>
          </div>
        </div>
        
          <div className="col-6 col-sm-12">
            <div className="card h-100">
              <img src="./s3/kwarren.jpg" className="card-img-top" alt=""
              />
              <div className="card-body">
                <div className="card-title h3">Kesean Warren</div>
                <div className="card-text h5">
                  Former Merced College Basketball Player. Former University of Waldorf Basketball Player. 3+ years as an NBA and Pro skills trainer.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid pt-3">
          <div className="container-fluid">
            <div className="row">
              <div className="col p-3 text-center">
                <div className="h1">
                  TRAIN LIKE A PRO!
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            <div className="row g-4">
              <div className="col-12 col-sm-6 col-lg-3">
                <div className="vertical-video-container">
                  <video className="position-absolute top-0 start-0 w-100 h-100" controls playsInline>
                    <source src="./s3/day1_1.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-3">
                <div className="vertical-video-container">
                  <video className="position-absolute top-0 start-0 w-100 h-100" controls playsInline>
                    <source src="./s3/day1_2.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-3">
                <div className="vertical-video-container">
                  <video className="position-absolute top-0 start-0 w-100 h-100" controls playsInline>
                    <source src="./s3/day2_1.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
              <div className="col-12 col-sm-6 col-lg-3">
                <div className="vertical-video-container" >
                  <video className="position-absolute top-0 start-0 w-100 h-100" controls playsInline>
                    <source src="./s3/day2_2.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
            </div>
          </div>
         </div>
    </div>
    <Footer />
  </>
);
}

export default BasketballCamps;
